export { PageCover } from './PageCover.component';
export type { PageCoverProps } from './PageCover.props';
